/** Matches `StateReportTabs.Outstanding` on State Reports Billing. */
export const STATE_REPORT_BILLING_OUTSTANDING_TAB = 3;

/**
 * Outstanding lists every Waiting on Client report, so Month/Year are hidden.
 * Upcoming and Completed still filter by the selected period.
 */
export function shouldShowStateReportBillingPeriodFilter(selectedTab: number): boolean {
  return selectedTab !== STATE_REPORT_BILLING_OUTSTANDING_TAB;
}
